module.exports = __webpack_public_path__ + "media/images/painter-img-2-14ae3c9c9dd4987ddf3a2505da604dae.jpg";